import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function FeaturedComics() {
  const featured = comics.sort((a, b) => b.views - a.views).slice(0, 6);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="mb-8">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
          热门推荐
        </h2>
        <p className="text-sm text-foreground-500 mt-1.5">精选全网最受欢迎的韩国漫画，不容错过的佳作</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {featured.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}